import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { IObservationFull, IRequisition } from '@project/view-models';
import { RequisitionDetailsManagerService } from '../../services/requisition-details-manager.service';
import { MeasurementPreview } from '../../../../project/modules/session-details-shared/session-details-shared-patient-observations/session-details-shared-patient-observations.component';
import { HcService } from '@project/services';

@Component({
  selector: 'app-session-details-patient-create-document',
  templateUrl: './session-details-patient-document-create-document.component.html',
  styleUrls: ['./session-details-patient-document-create-document.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionDetailsPatientDocumentCreateDocumentComponent {
  public observations$: Observable<IObservationFull[]> = this.requisitionDetailsManagerService.observations$;
  public readonly requisition$: Observable<IRequisition> = this.requisitionDetailsManagerService.requisition$;
  public readonly measurement$: Observable<MeasurementPreview> = this.requisitionDetailsManagerService.measurments$;
  public hasSelectedType = false;

  public documentForm = new FormGroup({
    type: new FormControl(''),
    content: new FormControl(''),
  });

  public documentTypes = [
    { label: 'Em branco', value: 'blank' },
    { label: 'Plano alimentar', value: 'prescription' },
    { label: 'Plano Terapêutico', value: 'statement' },
    { label: 'Plano de enfermagem', value: 'referral' },
  ];

  constructor(private requisitionDetailsManagerService: RequisitionDetailsManagerService, public hcService: HcService) {
    this.setupFormListeners();
  }

  private setupFormListeners(): void {
    this.documentForm.get('type')?.valueChanges.subscribe((value) => {
      this.hasSelectedType = !!value;
    });
  }

  onSubmit(): void {
    if (this.documentForm.valid) {
      const { type, content } = this.documentForm.value;
      console.log('Criar documento com:', { type, content });
    }
  }

  onCancel(): void {
    this.documentForm.reset();
  }
}
